import {Button, Modal, Table} from 'antd'
import {useEffect, useState} from "react";

export default function GoodsList(props){
    const {visible, dataList, close} = props
    const [tableData, setTableData] = useState([])

    useEffect(()=>{
        setTableData(dataList)
    },[visible])

    const columns = [
        {
            title: '商品信息',
            dataIndex: 'productName',
            render: (text, record) => {
                return (
                    <div style={{ fontSize: 12 }}>
                        <div style={{ color: '#1890ff' }}>{record.productName}</div>
                        <div>商品编码：{record.productCode}</div>
                        <div>商品条码：{record.barcode}</div>
                    </div>
                )
            }
        },
        {
            title: '规格',
            dataIndex: 'specification',
        },
        {
            title: '备货数量',
            dataIndex: 'stock',
        }
    ]

    return(
        <Modal
            visible={visible}
            width="60%"
            title="备货清单"
            onCancel={close}
            footer={[
                <Button key="back" onClick={close}>关闭</Button>,
            ]}
        >
            <Table
                rowKey={index=>index}
                dataSource={tableData}
                pagination={false}
                columns={columns}
            />
        </Modal>
    )
}
